<div *ngFor="let currencyIdentifier of commission.keys()">
  <app-money [currencyId]="currencyIdentifier" [value]="mangopayService.convertAmount(commission.get(currencyIdentifier), currencyIdentifier, true)"></app-money>
</div>
<div *ngIf="!areThereCommissions()" i18n="No commission">None</div>

